import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconAdd = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 8V6H4V8H18ZM16.798 11.5V14.2H19.498V15.8H16.798V18.5H15.198V15.8H12.498V14.2H15.198V11.5H16.798ZM14 10V12H4V10H14ZM11 16V14H4V16H11Z"
        />
      </svg>
    );
  }
);
